import { SlackIcon } from 'components/icons/v2/SlackIcon';
import { TelegramIcon } from 'components/icons';
import { WhatsappIcon } from 'components/icons/v2';

import { ILandingConfig } from 'types';
import { CommunityNode } from 'generated/types';

type CommunityConfigNode = Pick<CommunityNode, 'app' | 'displayLandingApplication'>;

export const getLandingConfig = (community?: CommunityConfigNode): ILandingConfig => {
  switch (community?.app?.toLowerCase()) {
    case 'slack':
      return {
        appName: 'Slack',
        icon: <SlackIcon width={28} height={28} />,
        showButton: community?.displayLandingApplication,
        buttonVariant: 'green',
        requirementsBgColor: 'bg-success-100',
        tags: {
          bgColor: 'bg-success-500',
          textColor: 'text-success-600'
        },
        benefits: {
          textColor: 'text-green-900',
          borderColor: 'border-transparent'
        },
        joinButton: '!text-success-500 hover:!text-success-600'
      };
    case 'telegram':
      return {
        appName: 'Telegram',
        icon: <TelegramIcon width={28} height={28} />,
        showButton: community?.displayLandingApplication,
        buttonVariant: 'blue',
        requirementsBgColor: 'bg-brand-100',
        tags: {
          bgColor: 'bg-blue-500',
          textColor: 'text-blue-600'
        },
        benefits: {
          textColor: 'text-blue-900',
          borderColor: 'border-blue-100'
        },
        joinButton: '!text-blue-500 hover:!text-blue-600'
      };
    case 'whatsapp':
      return {
        appName: 'WhatsApp',
        icon: <WhatsappIcon width={28} height={28} />,
        showButton: community?.displayLandingApplication || false,
        buttonVariant: 'green',
        requirementsBgColor: 'bg-success-100',
        tags: {
          bgColor: 'bg-success-500',
          textColor: 'text-success-600'
        },
        benefits: {
          textColor: 'text-green-900',
          borderColor: 'border-transparent'
        },
        joinButton: '!text-success-500 hover:!text-success-600'
      };
    default:
      return {
        appName: '',
        icon: null,
        showButton: community?.displayLandingApplication || false,
        buttonVariant: 'green',
        requirementsBgColor: 'bg-success-100',
        tags: {
          bgColor: 'bg-success-500',
          textColor: 'text-success-600'
        },
        benefits: {
          textColor: 'text-green-900',
          borderColor: 'border-transparent'
        },
        joinButton: '!text-success-500 hover:!text-success-600'
      };
  }
};
